const common = require("lib/labels/_common");

// Home.Settings

module.exports = {
  title: {
    en: "Settings",
    fr: "Paramètres"
  },
  selectTheme: {
    en: "Set theme",
    fr: "Thème sélectionné"
  },
  profile: common.profile,
  changePassword: {
    openLabel: common.password,
    curLogin: {
      label: {
        en: "Current Login",
        fr: "Identifiant actuel"
      },
      errEmpty: {
        en: "Login is empty",
        fr: "L'identifiant est vide"
      }
    },
    curPassword: {
      label: {
        en: "Current password",
        fr: "Mot de passe actuel"
      },
      errEmpty: {
        en: "Password is empty",
        fr: "Le mot de passe est vide"
      }
    },
    newPassword: {
      label: {
        en: "New password",
        fr: "Nouveau mot de passe"
      },
      ...common.passwordError,
    },
    confirmPassword: {
      label: {
        en: "Confirm new password",
        fr: "Confirmer le mot de passe"
      },
      differentPasswords: {
        en: "The two passwords are different",
        fr: "Les mots de passes sont différents"
      }
    },
    confirm: common.confirm,
    cancel: common.cancel
  },
  changeLogin: {
    openLabel: {
      en: "Login",
      fr: "Identifiant"
    },
    curLogin: {
      en: "Current login",
      fr: "Identifiant actuel"
    },
    newLogin: {
      en: "New login",
      fr: "Nouvel identifiant"
    },
    curPassword: {
      en: "Current password",
      fr: "Mot de passe actuel"
    },
    confirm: common.confirm,
    cancel: common.cancel,
    errPassLength: {
      en: "Password is empty",
      fr: "Le mot de passe est vide"
    },
    errExists: {
      en: "Login already exists",
      fr: "L'identifiant existe déjà"
    },
    errLength: {
      en: "Login is empty",
      fr: "L'identifiant est vide"
    }
  },
  changeAvatar: {
    openLabel: {
      en: "Profile image",
      fr: "Image de profil"
    },
    avatar: {
      en: "Image",
      fr: "Image"
    },
    password: common.password,
    confirm: common.confirm,
    cancel: common.cancel
  },
  changeEmail: {
    openLabel: common.email,
    newEmail: {
      label: {
        en: "New email",
        fr: "Nouvel email"
      },
      errInvalid: {
        en: "Invalid email",
        fr: "Email invalide"
      },
      errEmpty: {
        en: "Empty email",
        fr: "L'email est vide"
      },
      errExists: {
        en: "This email already exists",
        fr: "Cet email existe dèjà"
      },
      internal: {
        en: "Internal error",
        fr: "Erreur interne"
      }
    },
    curPassword: {
      label: {
        en: "Current password",
        fr: "Mot de passe actuel"
      },
      errLength: {
        en: "Password is empty",
        fr: "Le mot de passe est vide"
      }
    },
    confirm: common.confirm,
    cancel: common.cancel
  }
};
